import { Heading as WSRHeading, Size as WSRSize } from '@wix/design-system'
import classNames from 'classnames'
import React, { ComponentProps } from 'react'

import s from './Heading.scss'

type Size = WSRSize | 'xxl' | 'xxxl'
type Weight = 'normal'

type HeadingProps = Omit<ComponentProps<typeof WSRHeading>, 'size'> & {
  size: Size
  weight?: Weight
}

const getWsrSize = (size: Size): WSRSize => {
  if (size === 'xxl' || size === 'xxxl') {
    return 'extraLarge'
  }

  return size
}

export const Heading: React.FC<HeadingProps> = props => {
  return (
    <WSRHeading
      {...props}
      size={getWsrSize(props.size)}
      className={classNames({
        [s.Heading__xxl]: props.size === 'xxl',
        [s.Heading__xxxl]: props.size === 'xxxl',
        [s.Heading__fontWeightNormal]: props.weight === 'normal',
      })}
    />
  )
}
